import React from "react";

import { connect } from "react-redux";
import { getFacilityList, facilityRegApprove, viewBAAImage } from '../../services/employee/action';
import { toast } from "react-toastify";
import Pagination  from '../common/pagination';
import DeleteModel from '../common/Model/deleteModel';

class FacilityList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            facilityList: [],
            openPopUp: false,
            facilityName: "",
            officeEmail: "",
            officeFax: "",
            officePhone: "",
            address: "",
            address2: "",
            city: "",
            state: "",
            zip: "",
            npi: "",
            statusChange:"",
            imageSrc:"",
            pageOfItems : [],
            openStatusChangePopUp:false,
            facilityDetails : ""
        }
    }



    componentDidMount() {
        let token = this.props.loginDetails;

        
        this.props.getFacilityList(token);
    }


    componentWillReceiveProps = nextProps => {
        if (nextProps.getBaaImageStatus) {
            let imageSrc = nextProps.getBaaImage.facilityObj.filePath
           
                this.setState({
                    imageSrc
                })
        
        }

        if(nextProps.facilityRegStatusChange){
            //toast.success(nextProps.message);
            document.body.classList.remove('modal-open');        

            this.setState({
                openStatusChangePopUp:false,
                statusChange:true
            })
        }

        if (nextProps.getFacilityListStatus) {
            let facilityList = nextProps.getFacilityListData.facilityListObj;
            this.setState({
                facilityList
            })
        }
    }

    appendToModel = (facility) =>{

        let facilityName = facility.facilityName ? facility.facilityName : "";
        let officeEmail = facility.officeEmail ? facility.officeEmail : "";
        let officeFax = facility.officeFax ? facility.officeFax : "";
        let officePhone = facility.officePhone ? facility.officePhone : "";
        let address = facility.address ? facility.address : "";
        let address2 = facility.address2 ? facility.address2 : "";
        let city = facility.city ? facility.city : "";
        let state = facility.state ? facility.state : "";
        let zip = facility.zip ? facility.zip : "";
        let npi = facility.npi ? facility.npi : "";

        this.setState({
            facilityName,
            officeEmail,
            officeFax,
            officePhone,
            address,
            address2,
            city,
            state,
            zip,
            npi,

        },()=>{

            this.setState({
                openPopUp: true
            })
        })
    }   



    fullView = (e,facility) => {
        e.preventDefault();
        document.body.classList.add('modal-open');

        let token = this.props.loginDetails;
        this.appendToModel(facility);
   
        let id = facility.id

        this.props.viewBAAImage( token,id);

    }


    onChangePage = (pageOfItems) => {
         // update state with new page of items
         this.setState({ pageOfItems: pageOfItems });
     }

     openStatusPopUp = (facility) =>{
         this.setState({
             facilityDetails: facility
         },()=>{
         document.body.classList.add('modal-open');

             this.setState({
                 openStatusChangePopUp : true
             })
         })
     }
    

    changeStatus =  ( ) => {
        let facility = this.state.facilityDetails
        let status = "";
        if (facility.registrationStatus === "pending") {
            status = "approved"
        }   if (facility.registrationStatus === "approved") {
            status = "InActive"
        }  if (facility.registrationStatus === "InActive") {
            status = "approved"
        }



        let payLoad = {
            "id": facility.id,
        "registrationStatus": status
        }
        let token = this.props.loginDetails;

 

        
        this.props.facilityRegApprove(token, payLoad, )
    }

    closePopUpModal = () =>{
        document.body.classList.remove('modal-open');

        this.setState({
            openPopUp : false
        })
    }

    closePop = () =>{
        document.body.classList.remove('modal-open');

        this.setState({
            openStatusChangePopUp : false
        })
    }
 

    render() {

    //     if(imageSrc){
     //     const imgData = imageSrc.toDataURL('image/png');
    //     // const file = toBlob(imgData);
     // }
        const {
            facilityName,
            officeEmail,
            officeFax,
            officePhone,
            address,
            address2,
            city,
            state,
            zip,
            npi,
          
            imageSrc
        } = this.state
        

        return (
            <>
                <div className="bodyContent">

                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="titleBg">
                                        <h4>RegisteredONe Practice</h4>
                                    </div>
                            <div className="table-responsive">
                                <table className="table commonTable">
                                    <thead>
                                        <tr>
                                            <th>Status</th>
                                            <th>Practice</th>
                                            <th>Location</th>
                                            <th>View</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.pageOfItems.length > 0 ?
                                            this.state.pageOfItems.map((facility, id) => {
                                                return (
                                                    <tr key={id}>
                                                        <td><span className="statusconform"  title={facility.registrationStatus === "pending" ? "Pending" : facility.registrationStatus === "approved" ? "Active" : facility.registrationStatus == "InActive" ? "In - Active" : ""}  >
                                                        {facility.registrationStatus === "pending" ? "P" : facility.registrationStatus === "approved" ? "A" :  facility.registrationStatus === "InActive" ? "IA" : "" }</span></td>
                                                        <td>{facility.facilityName} </td>
                                                        <td>{facility.state}</td>
                                                        <td><a href="javascript:void(0)" onClick={(e) => this.fullView(e,facility)} className="icon" title="Download"><i className="fa fa-eye" aria-hidden="true"></i></a></td>
                                                        <td><button className="action-btn"  onClick={() => this.openStatusPopUp(facility)}   >
                                                            {facility.registrationStatus === "pending" ? "Approve" : facility.registrationStatus === "approved" ? "In - Activate"  :  facility.registrationStatus === "InActive" ? "Activate" : "" }</button></td>
                                                    </tr>
                                                )
                                            }) :<tr style={{background:"transparent"}}><td colspan="6"><img alt="" src="images/no-record-found.png" width="180px" style={{opacity:"0.6"}}/></td></tr>


                                        }
                                    </tbody>
                                </table>
                            </div>
                

<Pagination items={this.state.facilityList}   onChangePage={this.onChangePage} />

                        </div>

                    </div>
                </div>
                <DeleteModel header = "Edit" text="Are you sure you want to do this Action?" page="facilityList" status={this.state.openStatusChangePopUp} confirmOkay={this.changeStatus}  closePop={this.closePop}/>

 
                {this.state.openPopUp && 
                    <div className="creatTasks">
                        <div className="modal fade in " id="createtask" role="dialog">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">New Registered Practice Details</h4>
                                        <button type="button" className="close" onClick={this.closePopUpModal} >&times;</button>
                                    </div>

                                    <div className="modal-body">

                                        <div className="createtaskbody ">
                                            <div className="bgdefet">
                                                <div className="row">
                                                    <div className="form">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>PracticeName</label>
                                                                <span>{facilityName}</span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>NPI</label>
                                                                <span>{npi}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>OfficeEmail</label>
                                                                <span>{officeEmail}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>OfficeFax</label>
                                                                <span>{officeFax}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>OfficePhone</label>
                                                                <span>{officePhone}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>Address</label>
                                                                <span>{address}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>Address2</label>
                                                                <span>{address2}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>City</label>
                                                                <span>{city}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>State</label>
                                                                <span>{state}</span>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label>Zip</label>
                                                                <span>{zip}</span>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="bgdefet1">
                                                <h4 className="pract1">BAA Document</h4>
                                                <div className="pdf-file">
                                                    <img alt="" src={imageSrc} />
                                                </div>
                                            </div>


                                        </div>
                                        <div className="bgdefet">
                                            <div className="modal-footer1">
                                                <button type="button" onClick={() => { this.setState({ openPopUp: false }) }} className="btngeo clearbtn">Close</button>
                                                {/* <button type="button"  onClick={()=>{this.setState({openPopUp:false})}} className="btngeo submitbtn clr448aff" data-dismiss="modal">Submit</button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    }
}


const mapStateToProps = state => ({
    facilityRegStatusChange: state.employeeReducer.facilityRegStatusChange,
    loginDetails: state.commonReducer.loginDetails,
    profileDetails: state.commonReducer.profileDetails,
    getFacilityListData: state.employeeReducer.getFacilityListData,
    getFacilityListStatus: state.employeeReducer.getFacilityListStatus,
    getBaaImage : state.employeeReducer.getBaaImage,
    getBaaImageStatus : state.employeeReducer.getBaaImageStatus,
    getdata : state.employeeReducer.getdata,
    message : state.employeeReducer.meassge
});

const mapDispatchToProps = dispatch => ({
    getFacilityList: token => dispatch(getFacilityList(token)),
    facilityRegApprove: (token, payLoad, ) => dispatch(facilityRegApprove(token, payLoad, )),
    viewBAAImage : (  token, id) => dispatch(viewBAAImage(  token, id))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FacilityList); 